/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_Live_PageInputs */

const en_view_live_page = /** @type {(inputs: View_Live_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Live Page`)
};

const es_view_live_page = /** @type {(inputs: View_Live_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver página en vivo`)
};

const fr_view_live_page = /** @type {(inputs: View_Live_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir la page en ligne`)
};

const de_view_live_page = /** @type {(inputs: View_Live_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Seite ansehen`)
};

const ja_view_live_page = /** @type {(inputs: View_Live_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開中のページを見る`)
};

const zh_view_live_page = /** @type {(inputs: View_Live_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看实时页面`)
};

const ar_view_live_page = /** @type {(inputs: View_Live_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض الصفحة المباشرة`)
};

const id_view_live_page = /** @type {(inputs: View_Live_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Halaman Live`)
};

const it_view_live_page = /** @type {(inputs: View_Live_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi la Pagina Pubblica`)
};

const ru_view_live_page = /** @type {(inputs: View_Live_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотреть опубликованную страницу`)
};

const pt_view_live_page = /** @type {(inputs: View_Live_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver Página Ativa`)
};

const ko_view_live_page = /** @type {(inputs: View_Live_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라이브 페이지 보기`)
};

/**
* | output |
* | --- |
* | "View Live Page" |
*
* @param {View_Live_PageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const view_live_page = /** @type {((inputs?: View_Live_PageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_Live_PageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_view_live_page(inputs)
	if (locale === "es") return es_view_live_page(inputs)
	if (locale === "fr") return fr_view_live_page(inputs)
	if (locale === "de") return de_view_live_page(inputs)
	if (locale === "ja") return ja_view_live_page(inputs)
	if (locale === "zh") return zh_view_live_page(inputs)
	if (locale === "ar") return ar_view_live_page(inputs)
	if (locale === "id") return id_view_live_page(inputs)
	if (locale === "it") return it_view_live_page(inputs)
	if (locale === "ru") return ru_view_live_page(inputs)
	if (locale === "pt") return pt_view_live_page(inputs)
	return ko_view_live_page(inputs)
});